import { useQuery } from '@tanstack/react-query';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { orchestrationService } from '~/services';

interface UsePartnerCarrierSummariesOptions {
  partnerId?: string;
  disabled?: boolean;
}

export const usePartnerCarrierSummaries = (options: UsePartnerCarrierSummariesOptions) => {
  const { partnerId, disabled = false } = options;

  return useQuery({
    ...useQueryCreator(orchestrationService.carrierSummaries.search, {
      args: [partnerId ?? ''],
    }),
    refetchOnMount: true,
    enabled: !!partnerId && !disabled,
  });
};
